import Component from "@base/js/component";
import $ from "jquery";

export default class PerformanceRowWithSearch extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".performance-row-search";

  // Defines children that needs to be queried as part of this component
  static children = {
    rowItemsContainer: [".performance-row-search__item"],
    searchInput: ".performance-row-search__search-field-input",
    contentItemContainer: ".performance-row-search__content",
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    searchInput: {
      keyup: this.onSearchInputChange,
    },
  };

  afterInit() {
    const { rowItemsContainer } = this.children;

    const self = this;
    // to make sure that dom is rendered
    setTimeout(() => {
      rowItemsContainer.forEach((rowItemsParent) => {
        const seeMoreBtn = rowItemsParent.querySelector(
          ".performance-row-search__item-see-more"
        );
        const rowItems = rowItemsParent.querySelector(
          ".performance-row-search__item-links"
        );

        if (seeMoreBtn) {
          self.updateRowItemHeight(rowItems);
          const initialHeight = rowItems.getAttribute("data-collapse-height");
          rowItems.style.maxHeight = `${initialHeight}px`;

          seeMoreBtn.addEventListener("click", (ev) => {
            ev.preventDefault();
            if (rowItems.classList.contains("links-expanded")) {
              const height = rowItems.getAttribute("data-collapse-height");
              rowItems.style.maxHeight = `${height}px`;
              rowItems.classList.remove("links-expanded");
              $(rowItems).find("li:nth-child(n+4)").attr("tabindex", "-1");
              $(rowItems).find("li:nth-child(n+4)").attr("aria-hidden", true);
              $(rowItems).find("li:nth-child(n+4) a").attr("tabindex", "-1");
              $(rowItems).find("li:nth-child(n+4) a").attr("aria-hidden", true);
            } else {
              const height = rowItems.getAttribute("data-expanded-height");
              rowItems.style.maxHeight = `${height}px`;
              rowItems.classList.add("links-expanded");
              $(rowItems).find("li:nth-child(n+4)").attr("tabindex", "");
              $(rowItems).find("li:nth-child(n+4)").attr("aria-hidden", false);
              $(rowItems).find("li:nth-child(n+4) a").attr("tabindex", "");
              $(rowItems)
                .find("li:nth-child(n+4) a")
                .attr("aria-hidden", false);
              $(rowItems).find("li:nth-child(4) a").first().trigger("focus");
            }
          });
        }
      });

      window.addEventListener("resize", () => {
        this.updateRowHeightOnResize();
      });
    }, 250);

    const hiddenLinks = $(
      "ul.performance-row-search__item-links li:nth-child(n+4)"
    );
    if (hiddenLinks) {
      hiddenLinks.attr("tabindex", "-1");
      hiddenLinks.attr("aria-hidden", "true");
      hiddenLinks.find("a").attr("tabindex", "-1");
      hiddenLinks.find("a").attr("aria-hidden", "true");
    }
  }

  onSearchInputChange(ev) {
    const searchInputValue = $(ev.target).val().trim();
    if (searchInputValue.length > 0) {
      $(this.children.contentItemContainer).addClass("has-search-input-active");
      $(
        ".has-search-input-active .performance-row-search__item-link"
      ).removeClass("result-hidden");
      $(".has-search-input-active .performance-row-search__item").removeClass(
        "result-hidden"
      );
      $(this.children.contentItemContainer).removeClass("no-results");
      $(".has-search-input-active .performance-row-search__item-link").each(
        (i, item) => {
          if (
            $(item)
              .text()
              .toLowerCase()
              .includes(searchInputValue.toLowerCase())
          ) {
            const defaultText = $(item).text().trim();
            const regex = new RegExp(searchInputValue, "gi");
            if (defaultText.search(regex) !== -1) {
              $(item).html(defaultText.replace(regex, "<b>$&</b>"));
            }
          } else {
            $(item).addClass("result-hidden");
          }
        }
      );

      // hide section that is empty
      $(".has-search-input-active .performance-row-search__item").each(
        (i, item) => {
          const itemLink = $(item).find(
            ".performance-row-search__item-link:not(.result-hidden)"
          );
          if (itemLink.length === 0) {
            $(item).addClass("result-hidden");
          }
        }
      );

      // check if no results found

      const groupItems = $(this.children.contentItemContainer).find(
        ".performance-row-search__item-link:not(.result-hidden)"
      );
      if (groupItems.length === 0) {
        $(this.children.contentItemContainer).addClass("no-results");
        $(this.children.contentItemContainer)
          .find(".no-results-search-input")
          .html(searchInputValue);
      }
    } else {
      $(this.children.contentItemContainer).removeClass("no-results");
      $(".performance-row-search__item").removeClass("result-hidden");
      $(".performance-row-search__item-link").removeClass("result-hidden");
      $(this.children.contentItemContainer).removeClass(
        "has-search-input-active"
      );
    }
  }

  updateRowHeightOnResize() {
    const { rowItemsContainer } = this.children;

    rowItemsContainer.forEach((rowItemsParent) => {
      const rowItems = rowItemsParent.querySelector(
        ".performance-row-search__item-links"
      );
      this.updateRowItemHeight(rowItems);
    });
  }

  updateRowItemHeight(rowItems) {
    let totalCollapseHeight = 0;
    let totalExpandedHeight = 0;
    rowItems.querySelectorAll("li").forEach((el, index) => {
      const elementHeight = el.getBoundingClientRect().height;
      if (index < 3) {
        totalCollapseHeight += elementHeight;
      }
      totalExpandedHeight += elementHeight;
    });
    rowItems.setAttribute("data-collapse-height", `${totalCollapseHeight}`);
    rowItems.setAttribute("data-expanded-height", `${totalExpandedHeight}`);

    if (rowItems.classList.contains("links-expanded")) {
      const height = rowItems.getAttribute("data-expanded-height");
      rowItems.style.maxHeight = `${height}px`;
    } else {
      const height = rowItems.getAttribute("data-collapse-height");
      rowItems.style.maxHeight = `${height}px`;
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
PerformanceRowWithSearch.init();
